var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section section__coaches",attrs:{"id":"section4"}},[_c('div',{staticClass:"section__coaches-wrapper"},[_vm._m(0),_c('mentor-list')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-with-icon mb-2"},[_c('div',{staticClass:"title-with-icon__icon title-with-icon__icon_coach"}),_c('div',{staticClass:"title-with-icon__title"},[_vm._v("Наши наставники")])])
}]

export { render, staticRenderFns }